import { Link, useNavigate } from 'react-router-dom'
import { Button } from '@mui/material'
import './ToDashboardButton.css'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { KeyboardBackspace } from '@mui/icons-material'
import React from 'react'

export const ToDashboardButton = () => {

  const navigate = useNavigate()

  const backToDashboard = () => {
    navigate('/dashboard')
  }

  return (
    <div className="returnToDash">
                <Link to="/dashboard">
              <svg
                id="Layer_1"
                data-name="Layer 1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 122.88 108.06"
              >
                <title>back-arrow</title>
                <path d="M63.94,24.28a14.28,14.28,0,0,0-20.36-20L4.1,44.42a14.27,14.27,0,0,0,0,20l38.69,39.35a14.27,14.27,0,0,0,20.35-20L48.06,68.41l60.66-.29a14.27,14.27,0,1,0-.23-28.54l-59.85.28,15.3-15.58Z" />
              </svg>
              Back To Dashboard
            </Link>
    </div>
  // <span onClick={() => {
  //   navigate('/dashboard?tab=profile')
  // }} className="link" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
  //     <ArrowBackIosIcon fontSize="small"/>
  //     <span className="back-to-dashboard">Back to dashboard</span>
  //   </span>
  );
}